var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaintenanceLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 696.404,
    height: 703.173,
    viewBox: "0 0 696.404 703.173",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;opacity:0.21;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M348.206,703.173A343.154,343.154,0,0,1,212.67,675.544,346.881,346.881,0,0,1,101.988,600.2a353.508,353.508,0,0,1,0-497.218A346.883,346.883,0,0,1,212.67,27.63a346.24,346.24,0,0,1,271.07,0,346.873,346.873,0,0,1,110.679,75.349,353.513,353.513,0,0,1,0,497.218A346.87,346.87,0,0,1,483.74,675.544,343.147,343.147,0,0,1,348.206,703.173Zm49.7-541.719a246.641,246.641,0,0,0-196.9,96.929c-83.537,108.607-63.25,265.012,45.223,348.654a248.492,248.492,0,0,0,303-393.932A245.776,245.776,0,0,0,397.907,161.454Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaintenanceLogo);
export default __webpack_public_path__ + "static/media/maintenance-logo.7800fe534421ac01874ef3fc93d572f7.svg";
export { ForwardRef as ReactComponent };